export default function Price({ amount, currency = '' }: { amount: any; currency?: string }) {
  if (!amount) return currency ? null : '0';
  return <span style={{ whiteSpace: 'nowrap' }}>{`${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${currency ? ` ${currency}` : ''}`}</span>;
}
